import {Component, ViewChild, Input, Output, EventEmitter, ElementRef, SimpleChanges} from '@angular/core';
import {ClientContactsModel} from "../../../models/client-contacts/client-contacts.model";
import {ClientContactsType} from "../../../models/client-contacts/client-contacts.type";
import {Http} from "@angular/http";
import {ToasterService} from "angular2-toaster";
import {ActivatedRoute} from "@angular/router";
import {ApplicationUser} from "../../../services/ApplicationUser";
import {ClientsService} from "../../../models/clients/clients.service";
import {ClientVolumesService} from "../../../models/client-volumes/client-volumes.service";
import {ClientContactsService} from "../../../models/client-contacts/client-contacts.service";
import {ClientOwnersService} from "../../../models/client-owners/client-owners.service";
import {ClientBanksService} from "../../../models/client-banks/client-banks.service";
import {ClientProcessorsService} from "../../../models/client-processors/client-processors.service";
import {StaticDataService} from "../../../services/StaticData.service";

import * as _ from "lodash";
import * as moment from "moment/moment";

import {Observable} from 'rxjs/Observable';
import {IClientModel} from "../../../models/clients/clients.model";
import {ClientLocationsModel} from "../../../models/client-locations/client-locations.model";
import {ClientOwnersModel} from "../../../models/client-owners/client-owners.model";
import {ValidationService} from "../../../services/validation.service";
import {ProvincesService} from "../../../models/provinces/provinces.service";
import {ProvincesModel} from "../../../models/provinces/provinces.model";

import {phoneFormatter} from "../../../helpers/phone-format";

declare var $: JQueryStatic | any;


@Component({
    selector: 'owner-information',
    templateUrl: 'owner-information.template.html',
    exportAs: 'owner-information'
})
export class OwnerInformationComponent {
    @Input('client')
    @Output('client')
    public client;

    @Input('clientId')
    public clientId: number;

    @Input('editMode')
    public editMode = false;

    public moment = moment;

    public provinces = <ProvincesModel[]>  [];

    public clientOwners: ClientOwnersModel[] = [
        <ClientOwnersModel> {home_location: new ClientLocationsModel()},
        <ClientOwnersModel> {home_location: new ClientLocationsModel()},
        <ClientOwnersModel> {home_location: new ClientLocationsModel()},
    ];

    public loadingCount: any = 100000;


    public $ownersForm: any;

    constructor(
        private http: Http,
        private toasterService: ToasterService,
        private route: ActivatedRoute,
        public profile: ApplicationUser,
        public clientsService: ClientsService,
        public clientOwnersService: ClientOwnersService,
        protected validationService: ValidationService,
        protected el: ElementRef,
        public provincesService: ProvincesService
    ) {

    }


    ngOnInit() {
        this.loadingCount = 1;

        this.provincesService.getList()
            .subscribe((res) => {
                this.provinces = res.data;
                this.loadingCount--;
            }, (error) => {
                try {
                    let errorData = JSON.parse(error._body);
                    if (errorData.code / 1000 < 4.99) this.loadingCount--;
                } catch (ee) {}
            });

        this.loadByClientId();
    }

    loadByClientId() {
        this.loadingCount++;
        if (this.clientId) {
            this.clientOwnersService.getListByClient(this.clientId)
                .subscribe((res) => {
                    if (res.data.length) {
                        this.clientOwners = res.data;
                    } else {
                        this.clientOwners = [];
                    }

                    while (this.clientOwners.length < 6) {
                        this.clientOwners
                            .push(<ClientOwnersModel> {home_location: new ClientLocationsModel()});
                    }
                    this.loadingCount--;
                }, (error) => {
                    try {
                        let errorData = JSON.parse(error._body);
                        if (errorData.code / 1000 < 4.99) this.loadingCount--;
                    } catch (ee) {}
                });

        }
    }

    ngAfterViewInit() {
        this.$ownersForm = $('[name="owners-form"]', this.el.nativeElement);

        this.validateForm();
    }

    ngOnChanges(changes: any) {
        if (! changes.clientId) return;
        this.loadByClientId();
    }


    // ===========================================================
    // Actions
    // ===========================================================


    public copyAddress(indexOwner) {
        if(this.clientOwners[indexOwner]){
            this.clientOwners[indexOwner].home_location = this.clientOwners[0].home_location;
        }
    }

    public validate() {
        return this.$ownersForm.valid();
    }

    public save() {
        this.$ownersForm.submit();
    }

    public isLoaded() {
        return this.loadingCount < 0.1;
    }


    // ===========================================================
    // Functions
    // ===========================================================



    validateForm() {
        this.$ownersForm
            .validate({
                submitHandler: (form) => {
                    this.loadingCount++;
                    this.clientOwnersService.saveList(this.clientId, this.clientOwners)
                        .subscribe(
                            (res) => {
                                this.clientOwners = res.data;
                                this.loadingCount--;
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });

                    return false;

                }
            });

    }

    phoneFormatter = phoneFormatter;
}



// WEBPACK FOOTER //
// ./src/app/modules/client-forms/owner-information/owner-information.component.ts